export enum SessionStorageKeysEnum {
    ACCESS_TOKEN = 'accessToken',
    ALLIED_CODE = 'alliedCode',
    ALLOWED_ALLIES_RF = 'allowedAlliesRF',
    ALLOWED_CODES = 'allowedCodes',
    AUTH_INFO = 'authInfo',
    BFF_URL = 'bffUrl',
    BIOMETRIC_SERIAL = 'biometricSerial',
    BODY_FORMAT_RENEC = 'bodyFormatRnec',
    BRANCH = 'branch',
    BLOCK_PHOTOS_BY_DATA = 'blockPhotosByData',
    BLOCK_PHOTOS_BY_LABELS = 'blockPhotosByLabels',
    CANDIDATE = 'candidate',
    CC_REDIRECT_PILOT = 'cc-redirect-pilot',
    CC_REDIRECT_LANDING_URL = 'cc-redirectLandingUrl',
    CELL_PHONE = 'CellPhone',
    CELL_PHONE_NUMBER = 'cellphoneNumber',
    CHANNEL = 'channel',
    CUSTOMER_STATE = 'customerState',
    CURRENT_CONFRONTA_ATTEMPT = 'currentConfrontaAttempt',
    ERROR_CODE = 'errorCode',
    ESTRATEGIA_MARCA_TC = 'estrategiaMarcaTC',
    EMAIL = 'email',
    EXPDATE = 'expd',
    FINGER_LEFT_HAND = 'fingerLeftHand',
    FINGER_RIGHT_HAND = 'fingerRightHand',
    FIRST_AUTH_ATTEMPT = 'firstAuthAttempt',
    HARDWARE = 'hardware',
    IDENTIFY_TYPE_AUTHENTICATION = 'identifyTypeAuthentication',
    IDENTITY_NUMBER = 'identityNumber',
    IDENTITY_TYPE = 'identityType',
    IP = 'ip',
    IS_NEW_AGENT_VERSION = 'isNewAgentVersion',
    IS_FAIR = 'isFair',
    JOURNEY = 'journey',
    KEY_AUTHENTICATED_CELLPHONE = 'keyAuthenticatedCellPhone',
    LATITUDE = 'latitude',
    LIVENESS_ENABLED = 'livenessEnabled',
    LIVENESS_CHALLENGE = 'livenessChallenge',
    LIVENESS_CHALLENGE_LIST = 'livenessChallengesList',
    LIVENESS_MEDIUM_TYPE = 'livenessMediumTypes',
    LIVENESS_UPDATE_INVERVAL = 'livenessUpdateInterval',
    LONGITUDE = 'longitude',
    MAC = 'mac',
    MACHINE_TYPE = 'machineType',
    MILESTONE = 'milestone',
    MEDIUM_TYPE = 'mediumType',
    OFFICE_CODE = 'officeCode',
    OFFICE_NAME = 'officeName',
    OLIMPIA_METHOD = 'olimpiaMethod',
    PASSWORD_METHOD = 'passwordMethod',
    ONLY_SELFIE_ERROR = 'onlySelfieError',
    PRODUCT = 'product',
    PRODUCT_NAME = 'productName',
    PROD_SOLI_TARJETA1_CONVENIO = 'prodSoliTarjeta1Convenio',
    QUERY_PARAMS_COMPLETE = 'queryParamsComplete',
    RECOGNITION_CAMERA_RESOLUTION = 'recognitionCameraResolution',
    RECOGNITION_ENABLED = 'recognitionEnabled',
    RECOGNITION_MEDIUM_TYPES = 'recognitionMediumTypes',
    SAFE_DATA = 'safeData',
    SECOND_FACTOR = 'secondFactor',
    SECOND_FACTORS = 'secondFactors',
    SELF_MANAGEMENT = 'selfManagement',
    SELLER_IDENTITY_NUMBER = 'sellerIdentityNumber',
    SELLER_IDENTITY_NUMBER_LAUNCHER = 'sellerIdentityNumberLauncher',
    SELLER_IDENTITY_NUMBER_LDAP = 'sellerIdentityNumberLdap',
    SELLER_IDENTITY_NUMBER_FAIR = 'sellerIdentityNumberFair',
    SELLER_IDENTITY_TYPE = 'sellerIdentityType',
    SELFIE_PATH = 'selfiePath',
    SELLER_USER_NAME = 'sellerUsername',
    SESSION_ID_TM = 'uuidThreat',
    SITE = 'site',
    SPECIFIC_PRODUCT_INFO = 'specificProductInfo',
    SPECIFIC_PRODUCT_INFO_UUID = 'specificProductInfoUuid',
    TITTLE_FORMAT_RENEC = 'titleFormatRnec',
    USER = 'user',
    USER_ACCEPTED_TAC = 'userAcceptedTAC',
    UTM_UUID = 'utmUuid',
    TARGET_FILE_NAME = 'targetFileName',
    UUID = 'uuid',
    UUID_AUTH = 'uuidAuth',
    VALIDATE_OFFICE_CODE = 'validateOfficeCode',
    INGRESO_AUTENTICADOR = 'ingreso-autenticador',
    PRIVATE_IP = 'privateIp',
    PUBLIC_IP = 'publicIp',
}



// WEBPACK FOOTER //
// ./src/app/models/session-storage-keys-enum.ts